import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Row, Col } from "antd";

@inject('store')
@observer
class rooms extends Component {
    render() {
        const { onChangeTime, selectData } = this.props.store.general;
        const selected = {
            color: '#4c84ff'
        };
        return (
            <div className="rooms">
                <Row className="title">月度数据汇总</Row>
                <Row>
                    <Col span={12}>
                        <div className="total_style title_style">客房数据</div>
                        <div id="month-rooms" style={{ height: 400, width: '100%' }} />
                    </Col>
                    <Col span={12}>
                        <div className="total_style title_style">
                            <span>收入分布</span>

                        </div>
                        <div style={{ height: 400, width: '100%' }} id="month-rev" />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default rooms;


// WEBPACK FOOTER //
// ./src/components/BI/General/Month.js